<template>
  <span class="ss-reach" :title="title" role="img" :aria-label="title">
    <i class="ss-reach__b" :style="{ width: pct(before) }"></i>
    <i class="ss-reach__a" :style="{ width: pct(after) }"></i>
  </span>
</template>

<script>
const SCALE_DAYS = 21;

/** Dvije trake: koliko dana unaprijed radnik bira prije roka (puna) i poslije roka (blijeda). */
export default {
  name: "SetReach",
  inject: { ctl: "settingsCtl" },
  props: {
    before: { type: [Number, String], default: 0 },
    after: { type: [Number, String], default: 0 },
  },
  computed: {
    title() {
      return this.$t("settings_shell.dl.reach_title", {
        before: this.ctl.daysLabel(this.before),
        after: this.ctl.daysLabel(this.after),
      });
    },
  },
  methods: {
    pct(n) {
      return `${Math.max(0, Math.min(100, ((Number(n) || 0) / SCALE_DAYS) * 100))}%`;
    },
  },
};
</script>
